<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-tabs background-color="accent-4" centered dark icons-and-text>
      <v-tabs-slider></v-tabs-slider>

      <v-tab @click="comm_type('group-notice')">
        Notice
        <v-icon>mdi-file-star-outline</v-icon>
      </v-tab>

      <v-tab @click="comm_type('group-album')">
        Album
        <v-icon>mdi-image-album</v-icon>
      </v-tab>

      <v-tab @click="comm_type('group-calendar')">
        Calendar
        <v-icon>mdi-calendar</v-icon>
      </v-tab>
    </v-tabs>
    <v-card>
      <v-card-text>
        <router-view />
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    snackbar_msg: "",
    snackbar: false,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    //
    tab:'group-notice',
  }),
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    comm_type(type){
        this.tab = type;
        this.$router.push({ name: type})  
    },
  },
  mounted() {
      this.$router.push({ name: this.tab}) 
    // axios
    //   .post("")
    //   .then(res => {})
    //   .catch(error => {})
    //   .finally(() => {});
  }
};
</script>
<style scoped>
.app{
   background: #0F2027;  /* fallback for old browsers */
background: -webkit-linear-gradient(to right, #2C5364, #203A43, #0F2027);  /* Chrome 10-25, Safari 5.1-6 */
background: linear-gradient(to right, #2C5364, #203A43, #0F2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}
</style>